(function marketingPlanSaveForm($, Adzuki)
{
	"use strict";

	var form = {
		name      : 'MarketingPlanSave',
		submitted : false,
		serialized: null
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});
	
	
	form.load = function load()
	{
		var $jForm  = $('form[name="' + form.name + '"]');

		$jForm.submit(function formSubmitted(e) {
			form.submitted = true;
		});

		form.serialized = $jForm.serialize();

		// if user tries to leave this page, besides via a form submission, throw a warning that their info hasn't been saved
		$(window).on('beforeunload', function before() {
			var newSerializedForm = $jForm.serialize();
			if (form.submitted === false && form.serialized !== newSerializedForm) {
				return 'Are you sure you want to leave before finishing your Marketing Plan?';
			}

			return undefined; // do not show dialog if form hasn't changed at all
		});
	};
}(jQuery, window.Adzuki || {}));